export const ADMIN_PERMISSIONS = {
  upload: [],
  sourceInputs: ["admin"],
  snapshotBulk: ["snapshot-upload", "admin"],
  snapshotConfig: ["admin"],
  snapshotOrders: ["snapshot-orders", "admin"],
  ordersAnalytics: ["orders:read", "analytics:orders", "admin"],
  shareTemplates: ["admin", "university-admin", "social-media"],
  analytics: ["admin", "analytics-viewer", "analytics_viewer"],
  imports: ["admin", "import:read", "import:write"],
  importsWrite: ["admin", "import:write"],
  clipsExplorer: ["admin", "university-admin", "analytics-viewer", "analytics_viewer"],
  uploadNotifications: ["admin", "university-admin"],
  userManagement: ["admin"],
  supportReview: ["mgc-gmail-support"],
};

export function hasAnyRole(roles, required) {
  if (!Array.isArray(required) || required.length === 0) return true;
  const roleSet = new Set(Array.isArray(roles) ? roles : []);
  return required.some((r) => roleSet.has(r));
}

export function canAccess(roles, permissionKey) {
  const required = ADMIN_PERMISSIONS[permissionKey] || [];
  return hasAnyRole(roles, required);
}
